export const WS_URL = "wss://portal.anchordoc.ai"

export const GOOGLE_REDIRECT_URI = "https://anchordoc.ai/google_login"
export const GOOGLE_CLIENT_ID = "123454666001-mnsp5e1j8a380po2pi09dsguo5ge8qpi.apps.googleusercontent.com"
